import { useMemo } from 'react';

import { IconAssign } from '@components/icons/assign';
import { IconAssigned } from '@components/icons/assigned';
import { IconStatusIndicator } from '@components/icons/status-indicator';
import { FilterConfig } from '@components/table';
import { filterSeparator } from '@components/table/filters';

import { useAuthenticatedUser } from 'features/authentication';
import { useStore } from 'models/Provider';

import { useFilterAssignedTo } from './filter-assigned-to';
import { useJobsFilter } from './filter-jobs';
import { useMessageApplicantEmailFilter } from './filter-message-applicant-email';
import { useMessageApplicantNameFilter } from './filter-message-applicant-name';
import { useMessageCreatedFilter } from './filter-message-created';
import { useMessageLabelsFilter } from './filter-message-labels';
import { useMessageTextFilter } from './filter-message-text';

export const useMessagesTableFilterConfig = () => {
  const { t } = useStore();
  const me = useAuthenticatedUser();
  const dateFilter = useMessageCreatedFilter();
  const namesFilter = useMessageApplicantNameFilter();
  const emailsFilter = useMessageApplicantEmailFilter();
  const jobsFilter = useJobsFilter();
  const textsFilter = useMessageTextFilter();
  const labelsFilter = useMessageLabelsFilter();
  const assigneeFilter = useFilterAssignedTo();

  return useMemo<FilterConfig>(() => {
    return [
      {
        id: 'quick_filters',
        type: 'quick_filters',
        quick: [
          {
            id: 'quick-unread',
            label: t('messages.filters.quick.new.title'),
            icon: <IconStatusIndicator color="green100" />,
            apply: { category: 'labels', comparer: 'is', value: 'new' },
          },
          {
            id: 'quick-assigned-me',
            label: t('messages.filters.quick.assignedtome.title'),
            icon: <IconAssigned />,
            apply: { category: 'assignedto', comparer: 'is', value: String(me.id) },
          },
          {
            id: 'quick-unassigned',
            label: t('messages.filters.quick.assignedtonoone.title'),
            icon: <IconAssign />,
            apply: { category: 'assignedto', comparer: 'is', value: 'none' },
          },
        ],
      },
      dateFilter,
      namesFilter,
      emailsFilter,
      jobsFilter,
      textsFilter,
      labelsFilter,
      filterSeparator,
      assigneeFilter,
    ];
  }, [
    t,
    me.id,
    dateFilter,
    namesFilter,
    emailsFilter,
    jobsFilter,
    textsFilter,
    labelsFilter,
    assigneeFilter,
  ]);
};
